import type { ComponentType } from "react";
import type { RouteObject } from "react-router";

/**
 * Loads a screen module on first use (code splitting). The clock screen is the start page and
 * stays in the main bundle so that recording works immediately, also offline; feature routes such
 * as the setup (F-72, F-85) use the same loader instead of a copy.
 *
 * @param load - Dynamic import of the module.
 * @param pick - Selects the component from the module.
 * @returns The lazy route definition.
 */
export function lazyScreen<TModule>(
  load: () => Promise<TModule>,
  pick: (module: TModule) => ComponentType,
): NonNullable<RouteObject["lazy"]> {
  const lazy = async (): Promise<{ Component: ComponentType }> => {
    const module = await load();
    const route = { Component: pick(module) };

    return route;
  };

  return lazy;
}
